// extracted by mini-css-extract-plugin
module.exports = {"spinnerBackground":"LoadingSpinner_spinnerBackground__BOxgI","spinner":"LoadingSpinner_spinner__uPivd"};